{
  "entity": "收款申请",
  "create": "创建收款申请",
  "edit": "修改收款申请",
  "detail": "收款申请详情",
  "info": "收款申请信息",
  "request_no": "收款编号",
  "name": "收款名称",
  "payer": "付款方",
  "payee": "收款方",
  "payer_account": "付款方账号",
  "payee_account": "收款方账号",
  "payment_item": "款项",
  "currency": "应收币种",
  "receivable_amount": "应收金额",
  "received_amount": "已收金额",
  "pending_amount": "待收金额",
  "received_pending": "已收 / 待收",
  "status": "状态",
  "created_by": "创建人",
  "created_at": "创建时间",
  "business_object": "业务对象",
  "vehicle": "车辆",
  "non_vehicle": "非车辆",
  "description": "业务说明",
  "non_vehicle_description": "非车辆业务说明",
  "vehicles": "车辆明细",
  "vehicle_list": "收款申请车辆明细",
  "brand": "品牌",
  "model": "车型",
  "vin": "车架号",
  "quantity": "数量",
  "unit_amount": "金额",
  "total": "合计",
  "remark": "备注",
  "attachments": "附件",
  "customer_slips": "客户打款水单",
  "upload": "上传附件",
  "upload_hint": "支持任意格式，可批量上传",
  "history": "收款记录",
  "history_empty": "暂无收款记录",
  "close": "关闭",
  "modify": "修改",
  "remove": "删除",
  "save_draft": "保存草稿",
  "submit": "提交申请",
  "save_success": "保存成功！",
  "submit_success": "提交成功！",
  "delete_success": "删除成功！",
  "query_placeholder": "收款编号/名称/收款方/付款方",
  "disabled_tip": "单据当前为「{{status}}」，仅草稿或未到账状态可以操作",
  "delete_confirm": "您确定删除「{{number}}」吗？",
  "missing_id": "收款申请ID不存在",
  "missing_fund": "资金交易ID不存在",
  "required": "请输入{{field}}",
  "choose": "请选择{{field}}",
  "partner_placeholder": "请输入或选择{{field}}",
  "max_length": "{{field}}不能超过 {{max}} 个字符",
  "at_least_one": "请至少添加一辆车",
  "amount_warning": "车辆明细合计与应收金额不一致；草稿可以保存，提交时需使用车辆合计。",
  "correction_title": "车辆合计与应收金额不一致",
  "correction_content": "是否将应收金额调整为车辆合计 {{amount}} {{currency}} 后提交？",
  "correction_confirm": "调整并提交",
  "invalid_amount": "金额必须为非负数且最多两位小数",
  "invalid_total": "应收金额必须大于 0 且不能超过安全金额范围",
  "invalid_vin": "车架号需为 17 位字母或数字（不含 I、O、Q）",
  "duplicate_vin": "第 {{row}} 行车架号重复",
  "invalid_quantity": "每辆车的数量必须为 1",
  "confirm_receipt": "确认收款",
  "settlement_voucher": "收款流水单",
  "upload_voucher": "上传收款流水单",
  "zero_pending": "待收金额为零，可直接确认到账。",
  "workflow_description": "展示收款申请信息，确认收款节点可录入到账明细",
  "draft": "草稿",
  "receiving": "确认收款中",
  "fully_received": "全部收款",
  "partially_received": "部分收款",
  "not_received": "未到账"
}
